::ng-deep lib-transactions-content{display:flex;width:100%;flex-grow:1}::ng-deep lib-transactions-content .pos-relative{height:initial}::ng-deep lib-transactions-content mat-tab-group .mat-mdc-tab-body-wrapper{flex-grow:1}
/*# sourceMappingURL=transactions-content.component-2MUOSQGK.css.map */
